export default "__VITE_ASSET__DW4iFWQc__"